import { render, staticRenderFns } from "./Loaidng.vue?vue&type=template&id=6bd55a4c&"
import script from "./Loaidng.vue?vue&type=script&lang=js&"
export * from "./Loaidng.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports